import { push } from "connected-react-router/immutable";
import { isEmpty } from "lodash";
import { call, put, takeLatest } from "redux-saga/effects";
// import Client from "shopify-buy";
import { fetchAffiliatesRequest } from "storefront/features/account/actions";
import {
  customerErrorCode,
  removeCustomerAccessData,
} from "storefront/features/account/utils";
import * as globalActions from "storefront/features/shared/actions";
import {
  getCustomerAccessToken,
  getHeaders,
} from "storefront/features/shared/utils";
import superagent from "superagent";
import { STOREFRONT_API_URL } from "../../utils";
import * as actions from "./actions";
import {
  cartAddQuery,
  cartQuery,
  cartRemoveQuery,
  cartUpdateQuery,
  customerQuery,
} from "./utils";

// const client = Client.buildClient({
//   domain: process.env.SHOP,
//   storefrontAccessToken: process.env.STOREFRONT_ACCESS_TOKEN,
// });

export function* fetchUserAuctionDataRequest() {
  try {
    const multipassToken = localStorage.getItem("Multipass-Token");
    if (!multipassToken) {
      yield call(removeCustomerAccessData, "INVALID_MULTIPASS_REQUEST");
      return;
    }

    const request = () =>
      superagent
        .get(`/api/my_account/get_customer_auctions_data`)
        .query({ token: multipassToken });
    const response = yield call(request);
    const { cart_id } = response.body;
    yield put(actions.fetchUserAuctionDataRequestResult(response.body));
    yield call([localStorage, "setItem"], "Cart-Id", cart_id);
    yield put(actions.fetchCheckoutRequest(cart_id));
  } catch (res) {
    if (res.status === 400) {
      yield call(removeCustomerAccessData, "INVALID_MULTIPASS_REQUEST");
    }
    console.log(res);
  }
}

export function* fetchCustomerRequest(action) {
  const { loader, password } = action.payload;
  try {
    const vars = {
      customerAccessToken: getCustomerAccessToken(),
    };
    const graphBody = { query: customerQuery, variables: vars },
      headers = getHeaders();
    const request = () =>
      superagent.post(STOREFRONT_API_URL).set(headers).send(graphBody);
    const response = yield call(request);

    const customer = response.body.data.customer;
    yield put(globalActions.removeLoader({ loader }));
    if (customer) {
      const isUpdateCustomer =
        isEmpty(customer.firstName) && isEmpty(customer.lastName);
      const redirectLink = "/account/update_first_last_name";
      yield put(actions.fetchCustomerRequestResult(customer));
      if (!isEmpty(password)) {
        isUpdateCustomer
          ? yield put(
              push({
                pathname: redirectLink,
                state: { password, email: customer.email },
              })
            )
          : yield put(fetchAffiliatesRequest({ password, ...customer }));
      }
    } else {
      yield call(removeCustomerAccessData, customerErrorCode[1]);
    }
  } catch (res) {
    console.log(res);
  }
}

export function* fetchCheckoutRequest(action) {
  const cartId = action.payload;

  const graphBody = { query: cartQuery, variables: { id: cartId } },
    headers = getHeaders();
  const request = () =>
    superagent.post(STOREFRONT_API_URL).set(headers).send(graphBody);

  try {
    const response = yield call(request);
    response !== null
      ? yield put(
          actions.createCheckoutRequestResult(
            response.body?.data?.node?.lines?.nodes
          )
        )
      : yield put(actions.fetchUserAuctionDataRequest(response));
  } catch (res) {
    console.log(res);
  }
}

export function* addCheckoutLineItemsRequest(action) {
  const { cartId, lineItemsToAdd } = action.payload;
  const redirectLink = `/cart`;

  const graphBody = {
      query: cartAddQuery,
      variables: { cartId, lines: lineItemsToAdd },
    },
    headers = getHeaders();
  const request = () =>
    superagent.post(STOREFRONT_API_URL).set(headers).send(graphBody);

  try {
    const response = yield call(request);
    yield put(
      actions.createCheckoutRequestResult(
        response.body?.data?.cartLinesAdd?.cart?.lines?.nodes
      )
    );
    yield put(push(redirectLink));
  } catch (res) {
    console.log(res);
  }
}

export function* removeCheckoutLineItemsRequest(action) {
  const { cartId, lineItemIdsToRemove } = action.payload;

  const graphBody = {
      query: cartRemoveQuery,
      variables: { cartId, lineIds: lineItemIdsToRemove },
    },
    headers = getHeaders();
  const request = () =>
    superagent.post(STOREFRONT_API_URL).set(headers).send(graphBody);

  try {
    const response = yield call(request);
    yield put(
      actions.createCheckoutRequestResult(
        response.body?.data?.cartLinesRemove?.cart?.lines?.nodes
      )
    );
  } catch (res) {
    console.log(res);
  }
}

export function* updateCheckoutLineItemsRequest(action) {
  const { cartId, lineItemsToUpdate } = action.payload;

  const graphBody = {
      query: cartUpdateQuery,
      variables: { cartId, lines: lineItemsToUpdate },
    },
    headers = getHeaders();
  const request = () =>
    superagent.post(STOREFRONT_API_URL).set(headers).send(graphBody);

  try {
    const response = yield call(request);
    yield put(
      actions.createCheckoutRequestResult(
        response.body?.data?.cartLinesUpdate?.cart?.lines?.nodes
      )
    );
  } catch (res) {
    console.log(res);
  }
}

export default [
  takeLatest(actions.FETCH_CUSTOMER_REQUEST, fetchCustomerRequest),
  takeLatest(
    actions.FETCH_USER_AUCTION_DATA_REQUEST,
    fetchUserAuctionDataRequest
  ),
  takeLatest(actions.FETCH_CHECKOUT_REQUEST, fetchCheckoutRequest),
  takeLatest(
    actions.ADD_CHECKOUT_LINE_ITEMS_REQUEST,
    addCheckoutLineItemsRequest
  ),
  takeLatest(
    actions.REMOVE_CHECKOUT_LINE_ITEMS_REQUEST,
    removeCheckoutLineItemsRequest
  ),
  takeLatest(
    actions.UPDATE_CHECKOUT_LINE_ITEMS_REQUEST,
    updateCheckoutLineItemsRequest
  ),
];
